import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cb8149fc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=cb8149fc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8149fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\crmeb\\gitcode\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb8149fc')) {
      api.createRecord('cb8149fc', component.options)
    } else {
      api.reload('cb8149fc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cb8149fc&scoped=true", function () {
      api.rerender('cb8149fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OrderDetail/index.vue"
export default component.exports